import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["recipientType", "participantSelection", "recipientSummary"]
  static values = { tournamentName: String, approvedCount: Number }
  
  connect() {
    this.updateRecipientDisplay()
  }
  
  recipientTypeChanged() {
    this.updateRecipientDisplay()
  }
  
  participantChanged() {
    this.updateSummaryText()
  }
  
  updateRecipientDisplay() {
    const selectedType = this.recipientTypeTarget.value
    
    // Show/hide participant selection
    if (selectedType === 'selected_participants' || selectedType === 'single_participant') {
      this.participantSelectionTarget.classList.remove('hidden')
    } else {
      this.participantSelectionTarget.classList.add('hidden')
    }
    
    // Update summary text
    this.updateSummaryText()
    
    // Handle single participant constraint
    if (selectedType === 'single_participant') {
      this.setupSingleParticipantConstraint()
    }
  }
  
  updateSummaryText() {
    const selectedType = this.recipientTypeTarget.value
    const checkedBoxes = this.element.querySelectorAll('input[name="tournament_message[recipient_participant_ids][]"]:checked')
    
    let text = ''
    switch(selectedType) {
      case 'all_participants':
        text = `This message will be sent to all approved participants in the ${this.tournamentNameValue} tournament.`
        if (this.approvedCountValue > 0) {
          text += ` Currently, there are <strong>${this.approvedCountValue}</strong> approved participants.`
        }
        break
      case 'selected_participants':
        text = `This message will be sent to ${checkedBoxes.length} selected participants.`
        break
      case 'single_participant':
        if (checkedBoxes.length > 0) {
          const participantName = checkedBoxes[0].nextElementSibling.textContent
          text = `This message will be sent to ${participantName}.`
        } else {
          text = 'Please select one participant to receive this message.'
        }
        break
    }
    
    this.recipientSummaryTarget.innerHTML = text
  }
  
  setupSingleParticipantConstraint() {
    const checkboxes = this.element.querySelectorAll('input[name="tournament_message[recipient_participant_ids][]"]')
    
    checkboxes.forEach(checkbox => {
      // Remove existing listeners to avoid duplicates
      checkbox.removeEventListener('change', this.singleParticipantHandler)
      
      // Add new listener
      this.singleParticipantHandler = (event) => {
        if (event.target.checked) {
          checkboxes.forEach(other => {
            if (other !== event.target) other.checked = false
          })
        }
        this.updateSummaryText()
      }
      
      checkbox.addEventListener('change', this.singleParticipantHandler)
    })
  }
}